import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  computed,
  inject,
  OnInit,
  output,
  OutputEmitterRef,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';

import { NgGencatVerticalMenuItem } from '@shared/models/app-config.model';
import { SidebarTreeComponent } from '../sidebar-tree/sidebar-tree.component';
import { SidebarService } from '../services/sidebar.service';
import { RolePermissionDirective } from '@shared/directives/role-permission.directive';
import { FeatureFlagsDirective } from '@shared/directives/feature-flags.directive';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    NgClass,
    CommonModule,
    SidebarTreeComponent,
    RolePermissionDirective,
    FeatureFlagsDirective,
  ],
})
export class SidebarComponent implements OnInit {
  isSidebarCollapsed: WritableSignal<boolean> = signal(false);
  emitSidebarState: OutputEmitterRef<boolean> = output<boolean>();

  private readonly _sidebarService = inject(SidebarService);

  ngOnInit(): void {
    this.onSidebarToggle();
  }

  onSidebarToggle(): void {
    this.isSidebarCollapsed.update((value) => !value);
    this.emitSidebarState.emit(this.isSidebarCollapsed());
  }

  sidebarMenuItems: Signal<NgGencatVerticalMenuItem[]> = computed(() =>
    this._sidebarService.sidebarSignalState(),
  );
}
